const SldsCheckboxToggle = () => {
    return (
        <div class="slds-form-element">
            <label class="slds-checkbox_toggle slds-grid">
                <span class="slds-form-element__label slds-m-bottom_none"></span>
                <input type="checkbox" name="checkbox-toggle-15" value="checkbox-toggle-15" aria-describedby="checkbox-toggle-15" checked={true} />
                <span id="checkbox-toggle-15" class="slds-checkbox_faux_container">
                    <span class="slds-checkbox_faux"></span>
                    <span class="slds-checkbox_on">Enabled</span>
                    <span class="slds-checkbox_off">Disabled</span>
                </span>
            </label>
        </div>
    )
}

export default SldsCheckboxToggle;